import React from 'react';

type ThemedImageProps = {
    lightSrc: string;
    darkSrc: string;
    alt: string;
    className?: string;
};

export const ThemedImage: React.FC<ThemedImageProps> = ({
                                                            lightSrc,
                                                            darkSrc,
                                                            alt,
                                                            className = ''
                                                        }) => {
    return (
        <>
            {/* Gündüz modunda block (görünür), gece modunda hidden (gizli) */}
            <img
                src={lightSrc}
                alt={alt}
                className={`block dark:hidden ${className}`}
                loading="lazy"
                decoding="async"
            />

            {/* Gündüz modunda hidden (gizli), gece modunda block (görünür) */}
            <img
                src={darkSrc}
                alt={alt}
                className={`hidden dark:block ${className}`}
                loading="lazy"
                decoding="async"
            />
        </>
    );
};